import { render, staticRenderFns } from "./Status.vue?vue&type=template&id=01be61b4&scoped=true&"
import script from "./Status.vue?vue&type=script&lang=ts&"
export * from "./Status.vue?vue&type=script&lang=ts&"
import style0 from "./Status.vue?vue&type=style&index=0&id=01be61b4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01be61b4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('01be61b4')) {
      api.createRecord('01be61b4', component.options)
    } else {
      api.reload('01be61b4', component.options)
    }
    module.hot.accept("./Status.vue?vue&type=template&id=01be61b4&scoped=true&", function () {
      api.rerender('01be61b4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Card/Live/Status.vue"
export default component.exports